import {
  ColorSwatchProps as MantineColorSwatchProps,
  ColorSwatch as MantineColorSwatch,
} from '@mantine/core';

export type ColorSwatchProps = MantineColorSwatchProps;

export const ColorSwatch = MantineColorSwatch as typeof MantineColorSwatch;

ColorSwatch.displayName = 'ColorSwatch';
